import { InjectionToken } from '@angular/core';

export let REALM = new InjectionToken<string>('realm');
